import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import isEmpty from '../../utils/isEmpty';
import StreamField from '../../components/StreamField';
import CardListIndex from '../../components/CardListIndex/CardListIndex.js';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Button from '../../components/Button';

import styles from './CookiePage.module.scss';

import Hero from '../../components/Hero';

const CookiePage = ({
    breadcrumbs,
    hero,
    contentBlocks,
    title,
    cardListIndex,
}) => {
    const [loadingCookies, setLoadingCookies] = useState(false);
    const onClick = () => {
        setLoadingCookies(true);
        const tryClick = () => {
            const element = document.getElementById('csconsentlink');
            const isCookieScriptLoaded = window.CookieScript !== undefined;
            if (element && isCookieScriptLoaded) {
                element.click();
                clearInterval(intervalId);
                setLoadingCookies(false);
            }
        };

        const intervalId = setInterval(tryClick, 500);

        setTimeout(() => {
            clearInterval(intervalId);
        }, 10000);
    };

    return (
        <div className={styles['CookiePage']}>
            {!isEmpty(hero) && <Hero {...hero} />}
            <Breadcrumbs {...breadcrumbs} />

            <div className={styles['CookiePage__Container']}>
                <h1 className={styles['CookiePage__Title']}>{title}</h1>
                <div>
                    Om du vill uppdatera inställningar för dina kakor tryck på
                    knappen nedan.
                </div>
                <div className={styles['Button']}>
                    <Button
                        type="Primary"
                        onClick={onClick}
                        text={'Öppna cookie-inställningar'}
                        modifier={loadingCookies ? 'Disabled' : ''}
                    />
                </div>
            </div>

            {!isEmpty(contentBlocks) && <StreamField items={contentBlocks} />}

            <CardListIndex {...cardListIndex} />
        </div>
    );
};

export default basePageWrap(CookiePage);

CookiePage.propTypes = {
    breadcrumbs: PropTypes.object,
    hero: PropTypes.object,
    contentBlocks: PropTypes.array,
    title: PropTypes.string,
    cardListIndex: PropTypes.object,
};

CookiePage.defaultProps = {
    breadcrumbs: {},
    hero: {},
    contentBlocks: [],
    title: '',
    cardListIndex: {},
};
